import { OutputData } from '@editorjs/editorjs'

import { IBase, IBaseSeo } from './base'

export enum STATIC_PAGE_CONTENT_VARIANT_ENUM {
	EDITORJS = 'EDITORJS',
	TIPTAP = 'TIPTAP'
}

export interface IStaticPage extends IBase, IBaseSeo {
	content: OutputData
	contentTiptap: string
	contentVariant: STATIC_PAGE_CONTENT_VARIANT_ENUM
	slug: string
	title: string
}
